module.exports = __webpack_public_path__ + "img/lastlink.e1304b70.png";